import { render, staticRenderFns } from "./DuplicatesDetail.vue?vue&type=template&id=4eff02d1&scoped=true"
import script from "./DuplicatesDetail.vue?vue&type=script&lang=js"
export * from "./DuplicatesDetail.vue?vue&type=script&lang=js"
import style0 from "./DuplicatesDetail.vue?vue&type=style&index=0&id=4eff02d1&prod&scoped=true&lang=scss"
import style1 from "./DuplicatesDetail.vue?vue&type=style&index=1&id=4eff02d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eff02d1",
  null
  
)

export default component.exports